// extracted by mini-css-extract-plugin
module.exports = {"inlineBlock":"StatementDescriptor_inlineBlock__3oWCt","validationTips":"StatementDescriptor_validationTips__2aQ3R"};